export default {"src":"/_next/static/media/deposit.1901f9ab.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};